import { getApiClient } from './api-client';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface SessionResponse {
  user: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    email: string | null;
    username: string;
    imageUrl: string | null;
    isPlatformAdmin: boolean;
  };
  organization: {
    id: string;
    name: string;
    slug: string;
  };
  membership: {
    id: string;
    role: 'OWNER' | 'ADMIN' | 'MANAGER' | 'MEMBER';
    status: 'ACTIVE' | 'PENDING' | 'SUSPENDED' | 'DISABLED';
  };
  session: {
    id: string;
    expiresAt: string;
    idleExpiresAt: string;
  };
}

export interface OrganizationOption {
  id: string;
  name: string;
  slug: string;
  role: SessionResponse['membership']['role'];
  isCurrent: boolean;
}

export const authService = {
  login(data: LoginRequest) {
    return getApiClient().post<SessionResponse>('/auth/login', data);
  },
  session() {
    return getApiClient().get<SessionResponse>('/auth/session');
  },
  organizations() {
    return getApiClient().get<OrganizationOption[]>('/auth/organizations');
  },
  selectOrganization(organizationId: string) {
    return getApiClient().post<SessionResponse>('/auth/select-organization', {
      organizationId,
    });
  },
  logout() {
    return getApiClient().post<void>('/auth/logout');
  },
  changePassword(currentPassword: string, newPassword: string) {
    return getApiClient().post<void>('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },
};
